// 入荷確認の金額プリフィル（計算だけ。画面から切り出してテストできるように）
export function parseYen(v) {
  if (v === null || v === undefined || v === '') return null;
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  const s = String(v).replace(/[¥,\s\u3000]/g, '').trim();
  if (!s) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

// ¥1 バグ再発防止: `1` は既定プレースホルダーとして扱い、プリフィルには使用しない。
export function looksLikePlaceholderUnit(v) {
  const n = parseYen(v);
  return n !== null && n === 1;
}

/**
 * 単価と金額の初期値を決める。
 * 単価は必ず「この明細の単位」。TECHSの発注単位が違うとき（2セット vs 60本）は
 * セット単価をそのまま使わず、金額 ÷ 数量 にする。
 */
export function decideLinePrice(ln) {
  const qty = Number(ln.qty) || 0;
  const techsAmt = parseYen(ln.techs_amount);
  const techsUp = parseYen(ln.techs_unit_price);
  const receivedAmt = parseYen(ln.received_amount);
  const receivedUnit = looksLikePlaceholderUnit(ln.unit_price) ? null : parseYen(ln.unit_price);
  // ¥1 バグ跡: received_amount が qty と一致する場合は信頼しない（旧版で誤登録された値）
  const receivedLooksSuspicious =
    receivedAmt !== null && qty > 0 && Math.abs(receivedAmt - qty) < 1e-9;

  if (techsAmt !== null) {
    const derived = qty > 0 ? techsAmt / qty : null;
    const consistent = techsUp !== null && derived !== null
      && Math.abs(techsUp * qty - techsAmt) <= Math.max(1, Math.abs(techsAmt) * 0.01);
    return { unit: consistent ? techsUp : derived, amount: techsAmt, source: 'techs' };
  }
  if (receivedAmt !== null && receivedAmt > 0 && !receivedLooksSuspicious) {
    return {
      unit: receivedUnit !== null ? receivedUnit : (qty > 0 ? receivedAmt / qty : null),
      amount: receivedAmt, source: 'received',
    };
  }
  if (receivedUnit !== null && receivedUnit > 0 && qty > 0) {
    return { unit: receivedUnit, amount: receivedUnit * qty, source: 'master' };
  }
  return { unit: null, amount: null, source: 'none' };
}

const PACK_UNITS = ['セット', '箱', '袋', 'パック', 'ケース'];

/** 在庫に足す数量（在庫単位）。入数があるパック買いは換算する。 */
export function planStock(target, lineQty, lineUom, override) {
  const unit = target.unit || '個';
  const pack = Number(target.pack_qty) || 0;
  const before = Number(target.stock_before) || 0;
  const isPack = PACK_UNITS.some((p) => String(lineUom || '').includes(p)) && lineUom !== unit;
  if (override !== undefined && override !== null && override !== '') {
    const q = Number(override);
    return { stockQty: q, needsQtyInput: false, stockAfter: before + q,
      label: `${q} ${unit} を在庫に追加します` };
  }
  if (isPack && !pack) {
    return { stockQty: null, needsQtyInput: true, stockAfter: null,
      label: `入数が未登録のため、受入数量（${unit}）を入力してください` };
  }
  const q = isPack ? Number(lineQty) * pack : Number(lineQty);
  return {
    stockQty: q, needsQtyInput: false, stockAfter: before + q,
    label: isPack ? `${lineQty} ${lineUom} × ${pack} = ${q} ${unit} を在庫に追加します`
      : `${q} ${unit} を在庫に追加します`,
  };
}
